// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__APpg5","content":"LayoutSettings_content__qIYdK"};